import { RequestCookie } from 'next/dist/compiled/@edge-runtime/cookies'
import { getCookieValue } from '@/utils/common'
import { getAppConfig } from '@/config/config'

export function isPurMode(cookies: RequestCookie[]): boolean {
  const config = getAppConfig()
  console.log('Checking PUR mode with cookies:', cookies)
  console.log('Consent cookie value:', document?.cookie)
  // DPV
  return getCookieValue(cookies, config.consent.pur.cookie) === 'true' || navigator.userAgent.search('ntvAdFree') > -1
}
